interface LatestRequestGuard {
  cancel(): void
  isCurrent(requestNumber: number): boolean
  start(): number
}

// Lets only the newest request apply its answer; a cancelled or replaced request is ignored when it returns
const createLatestRequestGuard = (): LatestRequestGuard => {
  let latestRequestNumber = 0

  return {
    cancel: (): void => {
      latestRequestNumber += 1
    },
    isCurrent: (requestNumber: number): boolean => requestNumber === latestRequestNumber,
    start: (): number => {
      latestRequestNumber += 1
      return latestRequestNumber
    },
  }
}

export { createLatestRequestGuard, type LatestRequestGuard }
